import { render, staticRenderFns } from "./EditCustomerView.vue?vue&type=template&id=4f57144b&scoped=true&lang=pug&"
import script from "./EditCustomerView.vue?vue&type=script&lang=js&"
export * from "./EditCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerView.vue?vue&type=style&index=0&id=4f57144b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f57144b",
  null
  
)

export default component.exports